// Auto-detect API base URL:
// - Uses REACT_APP_BACKEND_URL if set (preview/dev environments)
// - Falls back to current window origin (self-hosted deployments)
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || window.location.origin;
const API = `${BACKEND_URL}/api`;

export { BACKEND_URL, API };
